export default __webpack_public_path__ + "static/media/discover.33fe7b18.svg";